import React, { useState } from 'react';
import config from '../../Context/Config'

const PhotoViewer = ({ chart, onClose }) => {
    const [photoUrl, setPhotoUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetchPhoto = async () => {
        if (photoUrl) return;
        setIsLoading(true);

        try {
            const response = await fetch(`${config.API_BASE_URL}/patient_image`, {
                method: "POST",
                headers: {
                    "action_id": config.ACTIONID['view'],
                    "Content-Type": "application/json",
                    "Authorization": `${localStorage.getItem("digital-form-idtoken")}`,
                    "practice": localStorage.getItem("digital-form-dept-practice")
                },
                body: JSON.stringify({ chart }),
            });

            const data = await response.json();
            setPhotoUrl(`data:image/png;base64,${data}`);
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    React.useEffect(() => {
        fetchPhoto();
    }, [chart]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="bg-white rounded-lg shadow-xl max-w-2xl max-h-[90vh] overflow-hidden">
                <div className="flex justify-between items-center p-4 bg-blue-600 text-white gap-3">
                    <h3 className="text-lg font-semibold">Photo Viewer</h3>
                    <button onClick={onClose}>Close</button>
                </div>
                <div className="p-4">
                    {isLoading ? (
                        <div className="text-center">Loading image...</div>
                    ) : (
                        <img src={photoUrl} alt="Patient" className="max-w-full max-h-96 object-contain mx-auto rounded-md"/>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PhotoViewer;